import { type ReactNode, useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: ReactNode;
}

interface FAQProps {
  items: FAQItem[];
  defaultOpenIndex?: number;
  variant?: 'light' | 'dark';
}

export function FAQ({ items, defaultOpenIndex = 0, variant = 'light' }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpenIndex);

  const borderColor = variant === 'dark' ? 'border-white/[0.12]' : 'border-[#E2E8F0]';
  const questionColor = variant === 'dark' ? 'text-white' : 'text-[#0A2540]';
  const answerColor = variant === 'dark' ? 'text-white/75' : 'text-[#4A5568]';

  return (
    <div className="mx-auto max-w-[800px] space-y-0">
      {items.map((item, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div key={idx} className={`border-b ${borderColor} py-5`}>
            <button
              onClick={() => setOpenIndex(isOpen ? null : idx)}
              className="flex w-full items-center justify-between text-left"
              aria-expanded={isOpen}
            >
              <span
                className={`pr-4 text-lg font-semibold transition-colors ${questionColor} ${
                  isOpen ? 'text-[#00D4AA]' : ''
                }`}
              >
                {item.question}
              </span>
              <ChevronDown
                size={20}
                className={`shrink-0 text-[#00D4AA] transition-transform duration-200 ${
                  isOpen ? 'rotate-180' : ''
                }`}
              />
            </button>
            <div
              className={`grid transition-all duration-200 ${
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className={`overflow-hidden pt-3 text-base leading-relaxed ${answerColor}`}>
                {item.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default FAQ;
